import classnames from 'classnames';
import React, { FC, useEffect, useState } from 'react';

import PublicBanner from 'Components/PublicBanner/PublicBanner';
import platformDetector from 'common/helpers/platformDetector';
import config from 'config/config';
import analytics from 'utils/analytics/analytics';
import routes from 'utils/routeTranslator';

import './PwfPromoBanner.scss';

type Props = {
  className?: string;
};

const PwfPromoBanner: FC<Props> = (props) => {
  const [imageUrl, setImageUrl] = useState<string>('');
  const hostCN = classnames('pwfPromoBanner', 'container', props.className);
  const targetPath = routes.get('front::pwf.promo');
  const actionUrl = `${config.SITE_URL}${targetPath}?utm_campaign=pwf_banner`;

  useEffect(() => {
    const src = platformDetector.isAnyMobile()
      ? 'https://cdn.fixly.pl/img/banners/pwf-promotion-mweb-x2.jpeg'
      : 'https://cdn.fixly.pl/img/banners/pwf-promotion-web-x2.jpeg';
    setImageUrl(src);
  }, []);

  return (
    <div className={hostCN}>
      <PublicBanner
        title="Skorzystaj z Płatności Fixly - zleć usługę i zapłać bezpiecznie w aplikacji!"
        imageUrl={imageUrl}
        href={actionUrl}
        openInNewTab
        onClick={() => {
          analytics.trackEvent('user_banner_click', {
            rel_entity_id: 'pwfPromotion2022',
          });
        }}
      />
    </div>
  );
};

export default PwfPromoBanner;
